/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Conditional } from '@cashfree-intl/coherent';

import Modal from './Modal';
import PaymentMethodsList from './PaymentMethodsList';
import UploadDocuments from './UploadDocuments';
import Confirmation from './Confirmation';
import EVENTS from '../../../../constants/analytics';
import Analytics from '../../../../utils/analytics';

const EnablePaymentMethods = ({
  closeModal,
  paymentMethods,
  onUpload,
  enablePaymentMethods,
  getDocsPerPaymentMethod,
  downloadDocument,
}) => {
  const [step, setStep] = useState(1);
  const [loading, setLoading] = useState(false);
  const [selectedMode, resetSelectedMode] = useState('');
  const [modeDetails, setModeDetails] = useState({});
  const [headerText, setHeaderText] = useState('Enable Payment Mode');

  const onEnable = () => {
    setLoading(true);
    Analytics.track(EVENTS.PAYMENT_METHODS.STEP_1_CLICK, {
      paymentMode: selectedMode,
    });
    // enable loading state here
    getDocsPerPaymentMethod({
      data: { paymentModeCode: selectedMode },
      successCb: response => {
        // see if documents are needed else directly show the confirmation modal
        // check for this flag - isDocRequired
        setModeDetails(response);
        setStep(step + 1);
        setHeaderText(
          response.isDocRequired ? 'Upload Documents' : 'Confirmation',
        );
        setLoading(false);
      },
      errorCb: () => {
        setLoading(false);
      },
    });
  };

  const onUploadSubmit = (values, actions) => {
    const files = [];
    const regDetails = [];

    const approvedTextFields = {};

    const fieldsToBeUploaded = { files: [], textFields: [] };

    if (modeDetails.documents)
      modeDetails.documents.forEach(obj => {
        if (obj.type === 'text' && obj.isApproved)
          approvedTextFields[obj.key] = true;
      });

    Object.keys(values).forEach(key => {
      if (typeof values[key] === 'object' && 'file' in values[key]) {
        files.push({ docType: key, file: values[key].file });
        fieldsToBeUploaded.files.push(key);
      } else if (
        ['number', 'string'].includes(typeof values[key]) &&
        !approvedTextFields[key]
      ) {
        regDetails.push({ regKey: key, regVal: values[key] });
        fieldsToBeUploaded.textFields.push(key);
      }
    });

    onUpload({
      fieldsToBeUploaded,
      files,
      regDetails,
      modeDetails,
      paymentModeCode: selectedMode,
      showError: () => {
        actions.setSubmitting(false);
      },
    });
  };

  const decrementStep = () => {
    setStep(step - 1);
    setHeaderText('Enable Payment Mode');
  };

  const onConfirm = () => enablePaymentMethods(selectedMode, modeDetails);

  return (
    <Modal closeModal={closeModal} step={step - 1} headerText={headerText}>
      <Conditional if={step === 1}>
        <PaymentMethodsList
          closeModal={closeModal}
          paymentMethods={paymentMethods}
          selectedMode={selectedMode}
          resetSelectedMode={resetSelectedMode}
          onEnable={onEnable}
          loading={loading}
        />
      </Conditional>
      <Conditional if={step === 2}>
        <Conditional if={modeDetails.isDocRequired}>
          <UploadDocuments
            closeModal={closeModal}
            modeDetails={modeDetails}
            decrementStep={decrementStep}
            handleFormSubmit={onUploadSubmit}
            downloadDocument={downloadDocument}
          />
        </Conditional>
        <Conditional if={!modeDetails.isDocRequired}>
          <Confirmation
            closeModal={closeModal}
            decrementStep={decrementStep}
            onConfirm={onConfirm}
            loading={loading}
            modeDetails={modeDetails}
          />
        </Conditional>
      </Conditional>
    </Modal>
  );
};

EnablePaymentMethods.propTypes = {
  paymentMethods: PropTypes.object,
  closeModal: PropTypes.func.isRequired,
  onUpload: PropTypes.func.isRequired,
  enablePaymentMethods: PropTypes.func.isRequired,
  getDocsPerPaymentMethod: PropTypes.func.isRequired,
  downloadDocument: PropTypes.func.isRequired,
};

export default EnablePaymentMethods;
